// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services
type IDataTag = {
  tagId: string;
  name: string;
  heading: boolean;
  tagged: boolean;
  description: string;
  rec: IDataTag[] | null;
};

interface ITaxonomyCanvasData {
  rec: IDataTag[];
}

export interface IGetTaxonomyRequest {
  params: { networkId: string };
  query?: { userId?: string | null };
}

export type IGetTaxonomyResponse = ITaxonomyCanvasData;

export function getTaxonomy({
  params,
  query
}: IGetTaxonomyRequest): Promise<IGetTaxonomyResponse> {
  return request(
    `${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.taxonomy`,
    {
      method: 'GET',
      query
    }
  );
}

export interface IGetTagRequest {
  params: { networkId: string };
  query: { tagId: string };
}

export interface IGetTagResponse {
  tagId: string;
  name: string;
  taxonomyId: string;
  taxonomyParentId: string;
  description: string;
  heading: boolean;
  sorting: number;
  created: string;
  updated: string;
}

export function getTag({
  params,
  query
}: IGetTagRequest): Promise<IGetTagResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.get`, {
    method: 'GET',
    query
  });
}

export interface IEditTagRequest {
  params: { networkId: string };
  query: { tagId: string };
  body: {
    name: string;
    description: string;
    heading: boolean;
    sorting: number;
  };
}

export interface IEditTagResponse {
  tagId: string;
  name: string;
  taxonomyId: string;
  taxonomyParentId: string;
  description: string;
  heading: boolean;
  sorting: number;
  created: string;
  updated: string;
}

export function editTag({
  params,
  query,
  body
}: IEditTagRequest): Promise<IEditTagResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.edit`, {
    method: 'POST',
    query,
    body: JSON.stringify(body)
  });
}

export interface ICreateTagRequest {
  params: { networkId: string };
  body: {
    name: string;
    description: string;
    sorting: number;
    heading: boolean;
    taxonomyParentId: string | null;
  };
}

export interface ICreateTagResponse {
  tagId: string;
  name: string;
  taxonomyId: string;
  taxonomyParentId: string;
  description: string;
  heading: boolean;
  sorting: number;
  created: string;
  updated: string;
}

export function createTag({
  params,
  body
}: ICreateTagRequest): Promise<ICreateTagResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.create`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IDeleteTagRequest {
  params: { networkId: string };
  query: { tagId: string };
}

export interface IDeleteTagResponse {}

export function deleteTag({
  params,
  query
}: IDeleteTagRequest): Promise<IDeleteTagResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.delete`, {
    method: 'POST',
    query
  });
}

export interface IMoveTagRequest {
  params: { networkId: string };
  query: { tagId: string; destinationTagId: string };
}

export interface IMoveTagResponse {
  tagId: string;
  name: string;
  taxonomyId: string;
  taxonomyParentId: string;
  description: string;
  heading: boolean;
  sorting: number;
  created: string;
  updated: string;
}

export function moveTag({
  params,
  query
}: IMoveTagRequest): Promise<IMoveTagResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/tags.move`, {
    method: 'POST',
    query
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/tag.ts